export default __webpack_public_path__ + "static/logo-med-035bd45f78211894381f8aaee7e82238.png";